// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for News component: column flow (3 cols desktop, 1 col mobile) */
.news-grid {
  column-count: 3;
  column-gap: 1.5rem;
}

.news-item {
  display: inline-block;
  width: 100%;
    max-height:  250px;
    min-height: 200px;
    overflow-y: auto;
  margin: 0 0 1.25rem 0;
  break-inside: avoid;
  page-break-inside: avoid;
  vertical-align: top;
  padding: 0;
}

.news-img-wrap {
  width: 100%;
  max-height: 220px;
  overflow: hidden;
  margin-bottom: 16px;
}

.news-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.news-body {
  padding: 0 8px 0 0;
}

.news-category {
  display: inline-block;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 700;
  color: #6b6b6b;
  border-left: 6px solid #c65b2a;
  padding-left: 10px;
  margin-bottom: 10px;
}

.news-title {
  font-size: 18px;
  line-height: 1.15;
  font-weight: 800;
  text-transform: uppercase;
  margin: 0 0 8px 0;
}

.news-date {
  font-size: 13px;
  margin-bottom: 12px;
}

.news-location {
  font-size: 13px;
  color: #444;
  margin-bottom: 8px;
}

.news-excerpt {
  margin-bottom: 12px;
}

.news-more {
  text-align: right;
  font-weight: 700;
}

.news-more a {
  text-decoration: none;
}

@media (min-width: 992px) {
  .news-grid { column-count: 3; }
}

@media (max-width: 991.98px) {
  .news-grid { column-count: 1; }
}

.news-separator {
  display: block;
  width: 90%;
  margin: 0.75rem auto;
  border: none;
  border-top: 1px solid #ddd;
  page-break-inside: avoid;
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
}

`, "",{"version":3,"sources":["webpack://./src/components/News.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB,qBAAqB;EACrB,mBAAmB;EAEnB,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa,eAAe,EAAE;AAChC;;AAEA;EACE,aAAa,eAAe,EAAE;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,wBAAmB;EAAnB,mBAAmB;EACnB,kCAAkC;AACpC","sourcesContent":["/* Styles for News component: column flow (3 cols desktop, 1 col mobile) */\n.news-grid {\n  column-count: 3;\n  column-gap: 1.5rem;\n}\n\n.news-item {\n  display: inline-block;\n  width: 100%;\n    max-height:  250px;\n    min-height: 200px;\n    overflow-y: auto;\n  margin: 0 0 1.25rem 0;\n  break-inside: avoid;\n  -webkit-column-break-inside: avoid;\n  page-break-inside: avoid;\n  vertical-align: top;\n  padding: 0;\n}\n\n.news-img-wrap {\n  width: 100%;\n  max-height: 220px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.news-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.news-body {\n  padding: 0 8px 0 0;\n}\n\n.news-category {\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n  color: #6b6b6b;\n  border-left: 6px solid #c65b2a;\n  padding-left: 10px;\n  margin-bottom: 10px;\n}\n\n.news-title {\n  font-size: 18px;\n  line-height: 1.15;\n  font-weight: 800;\n  text-transform: uppercase;\n  margin: 0 0 8px 0;\n}\n\n.news-date {\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n\n.news-location {\n  font-size: 13px;\n  color: #444;\n  margin-bottom: 8px;\n}\n\n.news-excerpt {\n  margin-bottom: 12px;\n}\n\n.news-more {\n  text-align: right;\n  font-weight: 700;\n}\n\n.news-more a {\n  text-decoration: none;\n}\n\n@media (min-width: 992px) {\n  .news-grid { column-count: 3; }\n}\n\n@media (max-width: 991.98px) {\n  .news-grid { column-count: 1; }\n}\n\n.news-separator {\n  display: block;\n  width: 90%;\n  margin: 0.75rem auto;\n  border: none;\n  border-top: 1px solid #ddd;\n  break-inside: avoid;\n  -webkit-column-break-inside: avoid;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
